export const booleanDefine = {
  TRUE_1: 1,
  TRUE_STR_1: '1',
  TRUE_Y: 'Y',
  TRUE_STR: 'true',
  FALSE_0: 0,
  FALSE_STR_0: '0',
  FALSE_N: 'N',
  FALSE_STR: 'false',
};

/**
 * 값이 true인지 여부를 판단한다.
 * @author Ju
 * @param  value
 * @return {Boolean}   true여부
 */
export function isTrue(value) {
  const dataType = typeof value;

  if (dataType === 'boolean') {
    return value;
  } else if (dataType === 'number') {
    return booleanDefine.TRUE_1 === value;
  } else if (dataType === 'string') {
    const valueStr = value.toUpperCase();
    return booleanDefine.TRUE_STR_1 === valueStr || booleanDefine.TRUE_Y.toUpperCase() === valueStr || booleanDefine.TRUE_STR.toUpperCase() === valueStr;
  }
  return value !== null && value !== undefined;
}

/**
 * 값을 Y/N으로 반환한다.
 * @author Ju
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function convertYN(value) {
  return isTrue(value) ? booleanDefine.TRUE_Y : booleanDefine.FALSE_N;
}

/**
 * 값을 1/0으로 반환한다.
 * @author Ju
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function convert01(value) {
  const me = this;
  return me.isTrue(value) ? me.TRUE_1 : me.FALSE_0;
}

/**
 * 값을 'true'/'false'로 반환한다.
 * @author Ju
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function convertBooleanStr(value) {
  const me = this;
  return me.isTrue(value) ? me.TRUE_STR : me.FALSE_STR;
}

/**
 * 값을 treu/false로 반환한다.
 * @author Ju
 * @param  {[type]} value [description]
 * @return {[type]}       [description]
 */
export function convertBoolean(value) {
  const me = this;
  return me.isTrue(value);
}



// WEBPACK FOOTER //
// ./src/utils/boolean.js